export var DefaultAuditLogResource = 'events';
